var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',{staticClass:"mb-3 text-center"},[_vm._v("Login or Sign Up")]),_c('div',{attrs:{"id":"auth"}})])}
var staticRenderFns = []

export { render, staticRenderFns }